import { defineComponent } from "vue";
import { mapState } from "pinia";
import { Container } from "aurelia-dependency-injection";

import { useHospiceConvertToPending } from "../../../../store/useHospiceConvertToPending";
import { PatientService } from "../../../../../../../services/patient.service";
import { ServiceLocations } from "../../../../../../../enums/ServiceLocationsEnum";
import { ServiceLocation } from "../../../../../../../resources-vue/vue-models/service-locations";
import { ToastrService } from "../../../../../../../services/toastr.service";

import TablePrompt from "../../../../../../../resources-vue/vue-custom-elements/TablePrompt/TablePrompt.vue";
import AddServiceLocationForm from "../AddServiceLocationForm/AddServiceLocationForm.vue";
import EmptyTextHandler from "../../../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";

export default defineComponent({
    components: {
        TablePrompt,
        AddServiceLocationForm,
        EmptyTextHandler
    },
    props: {
        resetList: {
            type: Function
        },
        columns: {
            type: Number
        },
        service: {
            type: Object
        }
    },

    computed: {
        ...mapState(useHospiceConvertToPending, ["accountId", "application", "patientId"])
    },

    data(vm) {
        return {
            _toastrService: null,
            patientService: null,
            isDeleteRequested: false,
            isEditRequested: false,
            isDeleteInProgress: false,
            cachedData: null,
            ServiceLocations
        };
    },
    created() {
        this.patientService = Container.instance.get(PatientService);
        this._toastrService = Container.instance.get(ToastrService);
    },

    methods: {
        openServiceForm() {
            this.isEditRequested = true;
        },

        confirmDeleteService() {
            this.isDeleteRequested = true;
        },

        closeEditService() {
            this.isEditRequested = false;
        },
        async deleteServiceLocation() {
            try {
                this.isDeleteInProgress = true;
                const payload = { agencyId: this.accountId, application: Number(this.application) };
                await this.patientService.deleteServiceLocation(payload, this.patientId, this.service.Id);
                this._toastrService.success({
                    title: `Service Location deleted successfully`
                });
                this.resetList();
            } catch (err) {
                console.error(err);
                this._toastrService.error({
                    title: `Failed to delete Service Location .Try Again !`
                });
            } finally {
                this.isDeleteInProgress = false;
                this.isDeleteRequested = false;
            }
        },
        cancelDeleteService() {
            this.isDeleteRequested = false;
        },
        openEditServiceLocation() {
            this.cachedData = new ServiceLocation(this.service);
            this.isEditRequested = true;
        },
        handleDeleteServiceLocation() {
            this.isDeleteRequested = !this.isDeleteRequested;
        }
    }
});

